// extracted by mini-css-extract-plugin
export default {"Vendor-order-container":"VendorOrder_Vendor-order-container__NbTQv","Vendor-order":"VendorOrder_Vendor-order__PRQz7"};